import { NgModule } from '@angular/core';

import { ApWebcomponentComponent } from '@ap/webcomponent';

import { ConversationalComponent } from './conversational.component';

@NgModule({
    declarations: [ConversationalComponent],
    imports: [ApWebcomponentComponent],
    exports: [ConversationalComponent]
})
export class ConversationalModule {}
